import '../styles/gouch.css';
import gouch from "url:../assets/gouch.png";
import { MusicPlayer } from './MusicPlayer';
import { InputField } from './InputField';
import { Button } from './Button';

export function Gouch() {
  return (
    <div className='gouch-page'>
      <h1>WHAT DO YOU HAVE TO SAY</h1>
      <img src={gouch} />
      <InputField onSubmit={() => {}} />
    </ div>
  );
}